export class AlreadyExistsError extends Error {
    constructor(type, id) {
        super(`${type} ${id} already exists`);
        this.type = type;
        this.id = id;
        this.name = AlreadyExistsError.name;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWxyZWFkeS1leGlzdHMtZXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWxyZWFkeS1leGlzdHMtZXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxPQUFPLGtCQUFtQixTQUFRLEtBQUs7SUFDM0MsWUFDVyxJQUFZLEVBQ1osRUFBVTtRQUVuQixLQUFLLENBQUMsR0FBRyxJQUFJLElBQUksRUFBRSxpQkFBaUIsQ0FBQyxDQUFDO1FBSDdCLFNBQUksR0FBSixJQUFJLENBQVE7UUFDWixPQUFFLEdBQUYsRUFBRSxDQUFRO1FBR25CLElBQUksQ0FBQyxJQUFJLEdBQUcsa0JBQWtCLENBQUMsSUFBSSxDQUFDO0lBQ3RDLENBQUM7Q0FDRiJ9